import { Section } from "design-system/molecules/Section"
import { useTranslation } from "react-i18next"

type Props = {
  title?: string | null
}

export function ChangeLogHeader({ title }: Props) {
  const { t } = useTranslation()

  return (
    <div className="bg-muted border-b px-6 py-3">
      <Section
        title={t("shared.changeHistory.title")}
        description={title ?? undefined}
        titleClassName="text-lg"
      />
    </div>
  )
}
